import { useEffect } from 'react';

import { useLocation, useParams } from 'react-router';
import { COUNTRY_TO_LANG } from 'src/modules/locales/config';
import { SupportedLanguages } from 'src/modules/locales/types';
import { useTranslation } from 'react-i18next';
import { isLanguageSupported } from '../../modules/locales/utils/isLanguageSupported';

/**
 * Эффект который отлавливает ситуацию, при которой юзер переключился на
 * новый язык, а затем нажал кнопку назад в браузере.
 */

export const useLanguageSync = () => {
  const location = useLocation();
  const { lang } = useParams();
  const {
    i18n: { changeLanguage }
  } = useTranslation();

  useEffect(() => {
    if (isLanguageSupported(lang)) {
      changeLanguage((lang as SupportedLanguages) || COUNTRY_TO_LANG.EN);
    }
  }, [location.pathname]);
};
